import request from '../utils/request';
import { IResult } from '../global';

interface IPost {
  content: string;
  galleryid: string;
}

const comment = {
  //删除
  del: (id: string) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/comment/destroy',
        method: 'post',
        data: { id },
        headers: {
          Authorization: request.token
        }
      })
        .then(jsonData => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  post: ({ content, galleryid }: IPost) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/comment/post',
        method: 'post',
        data: { content, galleryid },
        header: {
          Authorization: request.token
        }
      })
        .then(jsonData => {
          resolve(jsonData);
        })
        .catch(reject);
    });
  },
  list: (galleryid: string, time = Number.MAX_SAFE_INTEGER, pagesize = 50) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/comment/list',
        data: { galleryid, time, pagesize }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  top: (galleryid: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/comment/gallery/top',
        data: {
          galleryid
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  my: (galleryid: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/comment/my',
        data: { galleryid },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  }
};

export default comment;
